import React from "react";
import { BrowserRouter } from "react-router-dom";
import StoreApp from "./pages/StoreApp";

// Router shell; everything inside is the storefront (pages/StoreApp.js)
export default function App() {
    return (
        <BrowserRouter>
            <StoreApp />
        </BrowserRouter>
    );
}
